import { html, ref } from '@microsoft/fast-element';
import type { RecImpliedCarbonPrice } from './rec-implied-carbon-price';

export const RecImpliedCarbonPriceTemplate = html<RecImpliedCarbonPrice>`
  <div class="graph-div">
    <div
      style="height: 100%; display: ${(x) => (x.isVisible ? '' : 'none')}"
      ${ref('impliedCarbonPriceChart')}
    ></div>
  </div>
`;
